export const SRM_ITEMS_TAB_ID = "SRM-Details";
export const SRM_APPROVERS_TAB_ID = "SRM-Approvers";
